<template>
    <SlideWhite>
        <div class="h-full grid grid-cols-3 gap-[25px]">
            <div
                class="relative h-full flex items-end justify-center bg-no-repeat bg-cover bg-center col-span-2"
                :style="{ backgroundImage: `url(${require('@/assets/images/deckblatt_hintergrundbild.jpg')})` }"
            >
                <div class="absolute inset-0 z-10 bg-black/20"></div>

                <div class="absolute bottom-0 z-20">
                    <div class="flex space-x-[40px] mb-[222px] mx-[112px]">
                        <div class="bg-primary-500 w-[280px] h-[280px] flex-shrink-0 flex items-center justify-center">
                            <Logo class="w-[214px]" />
                        </div>
                        <div class="text-white flex flex-col justify-center items-center">
                            <img src="@/assets/images/Eigentumswohnungen_multilingual_01.png" alt="Eigentumswohnungen_multilingual_01.png" class="h-auto">
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-primary-500 text-white flex flex-col justify-between px-[75px]">
                <div class="text-right mt-[35px] text-[21.333px]">
                    <p class="leading-[35px]">
                        <span class="font-bold uppercase">Invest Berlin</span><br>
                        eine Marke von<br>
                        <span class="inline-block border border-white px-[10px] py-[4px] font-bold leading-none">estater.de</span>
                    </p>
                </div>

                <div class="mb-[245px] space-y-[35px]">
                    <p class="uppercase"><span class="font-bold text-[32px]">Invest Berlin</span><br><span class="text-[21.333px]">Shop Berlin-Steglitz</span></p>
                    <p class="text-[21.333px]">Feuerbachstr. 16<br>12163 Berlin</p>
                    <p class="font-bold text-[24px]">+49 (0)30 403678-0<br>www.invest-berlin.de</p>
                </div>
            </div>
        </div>
    </SlideWhite>
</template>

<script>
import Logo from '../Partials/Logo.vue'
import SlideWhite from '../Layouts/SlideWhite.vue'

export default {
    props: {

        activeSlide: {
            type: Boolean,
            default: false
        },
    },

    mounted() {},

    components: {
        SlideWhite,
        Logo,
    }
}
</script>